<template>
  <font-awesome-icon
    icon="columns"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faColumns } from '@fortawesome/free-solid-svg-icons'

library.add(faColumns)

export default {
  name: 'CoozzyColumnIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
